import React, { act, useEffect, useState } from 'react';
import { HamQuest } from '../../../App';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import { PointsBar } from '../LoyaltyCard';
import Button from '../../_common/form/Button';
import Modal from '../../_common/Modal';
import Row from '../../_common/form/Row';

const ConfirmModal = (award) => {
    console.log('Confirming award with ID:', award.pointAwardId);
    Modal.Confirmation({
        title: 'Claim ' + award.description,
        body: (
            <div>
                <p>Are you sure you want to spend {award.pointCost} points to claim this award?</p>
            </div>
        )
    })
    .then(res => {
        if (res) {
            HamQuest.put(QuestRoute.LoyaltyPointAwards + "/claim/" + award.pointAwardId)
                .then(() => {
                    Modal.Show({
                        type: 'success',
                        title: 'Award Claimed',
                        body: `You have successfully claimed the award: ${award.description}.`
                    });
                })
                .catch(err => {
                    Modal.Show({
                        type: 'error',
                        title: 'Claim Failed',
                        body: 'There was an error claiming the award. Please try again later.'
                    });
                });
            console.log('Award confirmed:', award.pointAwardId);
        }
        Modal.Close();
    
    });
};

const LoyaltyPoints = () => {
    const {
        state: {
            active_user,
            site_config
        },
        getLoyaltyAwards
    } = useGlobalState();

    const [userPoints, setUserPoints] = useState(null);
    const awards = site_config.loyaltyAwards || [];

    useEffect(() => {
        if (!active_user.isLoggedIn) return;
        if (!awards.length) {
            getLoyaltyAwards();
        }
        HamQuest.get(QuestRoute.user.loyaltyPoints)
            .then(res => {
                setUserPoints(res.current_points);
            });
    }, []);

    if (!awards || awards.length === 0 || userPoints === null) {
        return <div>Loading...</div>;
    }

    const maxPoints = awards != null && awards.length > 0 ? awards[awards.length - 1].pointCost : 0;
    const progressPercent = maxPoints ? Math.min((userPoints / maxPoints) * 100, 100) : 0;

    return (
        <div style={{ width: '85%', margin: '0 auto', padding: 24 }}>
            <div style={{ marginBottom: 16 }}>
                <strong>Your Points:</strong> {userPoints}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <PointsBar
                    points={userPoints}
                    goal={maxPoints}
                    awards={awards}
                    site_config={site_config}
                />
            </div>
            <div style={{ marginTop: 24 }}>
                <h3>Possible Awards</h3>
                <ul>
                    {awards.map(award => (
                        <Row key={award.pointAwardId} style={{ color: userPoints >= award.pointCost ? '#4caf50' : '#888' }}>
                                {award.description} ({award.pointCost} points)
                                {userPoints >= award.pointCost && <Button style={{ marginLeft: 8 }} onClick={() => {ConfirmModal(award)}}>Claim</Button>}
                        </Row>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default LoyaltyPoints;